import { render, staticRenderFns } from "./NestedRouteWrapper.vue?vue&type=template&id=2117a219"
import script from "./NestedRouteWrapper.vue?vue&type=script&lang=ts"
export * from "./NestedRouteWrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports